// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/shared/tray/tray.scss
// module id = 189
// module chunks = 0